import type { ReactElement } from "react";
import { EXPORT_FORMAT_OPTIONS } from "../../src/export-formats.js";
import type { ExportFormat } from "../../src/contracts.js";

type VideoFormatSelectionBoxProps = {
  value: ExportFormat;
  disabled: boolean;
  onChange: (format: ExportFormat) => void;
};

/** Reusable format selector displayed alongside the video creation workflow. */
export function VideoFormatSelectionBox({ value, disabled, onChange }: VideoFormatSelectionBoxProps): ReactElement {
  return <section className="video-format-selection-box" aria-labelledby="video-format-title">
    <div className="video-format-copy"><span aria-hidden="true">▣</span><div><h2 id="video-format-title">Video format</h2><p>Choose the best format for your platform.</p></div></div>
    <label className="video-format-select"><span className="sr-only">Video format</span><select value={value} disabled={disabled} onChange={(event) => onChange(event.target.value as ExportFormat)}>{EXPORT_FORMAT_OPTIONS.map((format) => <option value={format.id} key={format.id}>{format.label} ({format.aspectLabel})</option>)}</select></label>
  </section>;
}
